import { useRouter } from "next/router"
import { createRef, RefObject } from "react"
import styled, { css } from "styled-components"

import Button from "~/components/atoms/Button"
import Logo from "~/components/atoms/Logo"
import Pc from "~/components/atoms/Pc"
import Sp from "~/components/atoms/Sp"
import Typography from "~/components/atoms/Typography"
import { Container } from "~/components/layouts/Container"
import Footer from "~/components/organisms/Footer"
import Header from "~/components/organisms/Header"
import { Color } from "~/consts/style-mixins"
import { useMobileMedia } from "~/hooks/useMobileMedia"
import { staticPath } from "~/services/helper"

import { Form } from "./form"
import * as Styled from "./styled"

export const NewGradScoutCorpContact: React.VFC = () => {
  const router = useRouter()
  const formRef = createRef<HTMLDivElement>()
  const featurePointFirstRef = createRef<HTMLDivElement>()
  const featurePointSecondRef = createRef<HTMLDivElement>()
  const featurePointThirdRef = createRef<HTMLDivElement>()

  const scrollTo = (ref: RefObject<HTMLDivElement>) => {
    const targetElement = ref
    targetElement?.current?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <>
      <Pc>
        <PcHeader onClick={() => scrollTo(formRef)} />
      </Pc>
      <Sp>
        <Header logoType="NewGradScout" />
        <FixBottom onClick={() => scrollTo(formRef)} />
      </Sp>
      <Styled.NewGradScoutCorpContactContainer>
        <Styled.Section>
          {/* <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-line-l.png")}`}
            className="decoration-line ll l1"
          /> */}
          <MainVisual onClick={() => scrollTo(formRef)} />
        </Styled.Section>
        <Styled.Section>
          <Feature
            scrollToPointFirst={() => scrollTo(featurePointFirstRef)}
            scrollToPointSecond={() => scrollTo(featurePointSecondRef)}
            scrollToPointThird={() => scrollTo(featurePointThirdRef)}
          />
          {/* <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-square-1.png")}`}
            className="decoration d1"
          /> */}
        </Styled.Section>
        <Styled.Section>
          {/* <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-line-s.png")}`}
            className="decoration-line ls l2"
          />
          <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-line-l.png")}`}
            className="decoration-line ll l3"
          /> */}
          <div ref={featurePointFirstRef}></div>
          <FeaturePointFirst scrollToForm={() => scrollTo(formRef)} />
          <div ref={featurePointSecondRef}></div>
          <FeaturePointSecond scrollToForm={() => scrollTo(formRef)} />
          <div ref={featurePointThirdRef}></div>
          <FeaturePointThird scrollToForm={() => scrollTo(formRef)} />
        </Styled.Section>
        <Styled.Section>
          <Seminar scrollToForm={() => scrollTo(formRef)} />
        </Styled.Section>
        <Styled.Section>
          {/* <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-line-l.png")}`}
            className="decoration-line ll l10"
          /> */}
        </Styled.Section>
        <Styled.Section>
          {/* <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-square-6.png")}`}
            className="decoration d13"
          />
          <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-line-l.png")}`}
            className="decoration-line ll l13"
          />
          <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-line-s.png")}`}
            className="decoration-line ls l14"
          />
          <img
            src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-line-l.png")}`}
            className="decoration-line ll l15"
          /> */}
          <div ref={formRef}></div>
          <Form complete={router && router.query.submit === "complete"} />
        </Styled.Section>
      </Styled.NewGradScoutCorpContactContainer>
      <Footer />
    </>
  )
}

// Common
interface HeadingProps {
  number: string
  text: string
}

const Heading = ({ number, text }: HeadingProps) => {
  return (
    <Styled.HeadingContainer>
      <div className="heading-icon-number">
        <img
          src={staticPath("/static/images/new-grad-scout/corp-contact/point-icon.svg")}
          alt=""
          className="heading-icon"
        />
        <span className="heading-number">{number}</span>
      </div>
      <h3 className="heading-text">{text}</h3>
    </Styled.HeadingContainer>
  )
}

interface CvAppealProps {
  onClick: () => void
  description: string
  imgSrc: string
}
const CvAppeal = ({ onClick, description, imgSrc }: CvAppealProps) => {
  return (
    <Styled.CvAppealContainer onClick={onClick} bgImgSrc={imgSrc}>
      <Pc>
        <div className="cv-appeal-content">
          <img src={staticPath(imgSrc)} className="cv-appeal-content_img" />
          <div className="cv-appeal-content_inner">
            <Typography type="SubHeading" className="cv-appeal-content_message">
              {"＼" + description + "／"}
            </Typography>
            <Button size="Medium" className="cv-appeal-content_button" onClick={onClick}>
              資料請求・お問い合わせ
            </Button>
          </div>
          <img src={staticPath("/static/images/new-grad-scout/corp-contact/cv-appeal-arrow.svg")} alt="" />
        </div>
      </Pc>
      <Sp>
        <div className="cv-appeal-content">
          <div className="cv-appeal-content_inner">
            <Typography type="SubHeading" className="cv-appeal-content_message">
              {"＼" + description + "／"}
            </Typography>
            <Button size="Medium" onClick={onClick} className="cv-appeal-content_button">
              資料請求・お問い合わせ
            </Button>
          </div>
        </div>
      </Sp>
    </Styled.CvAppealContainer>
  )
}

interface OnClickProps {
  onClick: () => void
}
const PcHeader = ({ onClick }: OnClickProps) => {
  return (
    <Styled.PcHeaderContainer>
      <Container size="Large">
        <div className="pc-header-inner">
          <a href="./" className="pc-header-inner_logo-area">
            <Logo type="NewGradScout" height={32} />
          </a>
          <a href={`${process.env.INFRA_INTERN_URL}/long-internship`} className="pc-header-inner_center">
            長期インターン採用はこちら
          </a>
          <div className="pc-header-inner_right">
            <p className="pc-header-inner_tel">TEL：03-6433-1288</p>
            <Button size="Small" onClick={onClick} className="pc-header-inner_button">
              資料請求・お問い合わせ
            </Button>
          </div>
        </div>
      </Container>
    </Styled.PcHeaderContainer>
  )
}

const FixBottom = ({ onClick }: OnClickProps) => {
  return (
    <Styled.FixBottomContainer>
      <div className="fix-bottom-inner">
        <div className="fix-bottom-inner_item">
          <img
            src={staticPath("/static/images/new-grad-scout/corp-contact/fix-bottom-tel.png")}
            className="fix-bottom-inner_item-icon"
          />
          <a href="tel:03-6433-1288" className="fix-bottom-inner_item-tel">
            03-6433-1288
          </a>
        </div>
        <div className="fix-bottom-inner_item" onClick={onClick}>
          <img
            src={staticPath("/static/images/new-grad-scout/corp-contact/fix-bottom-cv.png")}
            className="fix-bottom-inner_item-icon"
          />
          <p className="fix-bottom-inner_item-cv">お問い合わせ</p>
        </div>
      </div>
    </Styled.FixBottomContainer>
  )
}

interface MainVisualProps {
  onClick: () => void
}
const MainVisual = ({ onClick }: MainVisualProps) => {
  const isMobile = useMobileMedia()

  return (
    <Styled.MainVisualContainer>
      <div className="inner">
        <Pc>
          <img src={staticPath("/static/images/new-grad-scout/corp-contact/mv-mask.png")} className="mv-mask" alt="" />
        </Pc>
        <img
          src={staticPath("/static/images/new-grad-scout/corp-contact/mv-decorate-bold-line.png")}
          className="mv-decoration-bold-line"
          alt=""
        />
        <img
          src={`${staticPath("/static/images/new-grad-scout/corp-contact/decoration-line-l.png")}`}
          className="mv-decoration-line"
          alt=""
        />
        <Container size="Large" className="container">
          <h1 className="hero">
            ここでしか出会えない
            <br />
            優秀な早期行動学生に、
            <br />
            いち早くスカウトでアプローチ。
          </h1>
          <Button size="Medium" onClick={onClick} className="mv-button">
            資料請求・お問い合わせ
          </Button>
        </Container>
        <img
          src={
            isMobile
              ? `${staticPath("/static/images/new-grad-scout/corp-contact/mv-feature-circles-sp.png")}`
              : `${staticPath("/static/images/new-grad-scout/corp-contact/mv-feature-circles.png")}`
          }
          className="mv-feature-circles"
          alt="Infra 新卒スカウトが選ばれる3つの特徴"
        />
      </div>
    </Styled.MainVisualContainer>
  )
}

interface FeatureProps {
  scrollToPointFirst: () => void
  scrollToPointSecond: () => void
  scrollToPointThird: () => void
}

const Feature = ({ scrollToPointFirst, scrollToPointSecond, scrollToPointThird }: FeatureProps) => {
  const isMobile = useMobileMedia()

  return (
    <Styled.FeatureContainer>
      <div className="what-is">
        <div className="what-is-heading">Infra 新卒スカウトとは</div>
        <p className="what-is-description">
          早期から行動している優秀人材に、
          <UnderlineText fontSize={isMobile ? 13 : 18}>ピンポイントでアプローチ</UnderlineText>できる
          {!isMobile && <br />}
          ダイレクトリクルーティングサービスです
        </p>
      </div>
      <Container size="Large" className="section-container">
        <h2 className="heading-2">
          Infra 新卒スカウトが選ばれる、
          {isMobile && <br />}
          <span className="heading-2 green">
            <span className="heading-2 green large">3</span>つの特徴。
          </span>
        </h2>
        <div className="feature-container">
          <div className="feature-item first" onClick={scrollToPointFirst}>
            <div className="feature-item-point">
              <div className="feature-item-point-text">POINT</div>
              <div className="feature-item-point-number">01</div>
            </div>
            <div>
              <p className="feature-item-description">
                優秀人材に特化した
                <br />
                学生データベース
              </p>
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/feature-illustration-01.png")}
                alt="優秀人材に特化した学生データベース"
                className="feature-illustration first"
              />
            </div>
            <img
              src={staticPath("/static/images/new-grad-scout/corp-contact/feature-arrow.svg")}
              alt=""
              className="feature-arrow"
            />
          </div>
          <div className="feature-item-second-third-container">
            <div className="feature-item second" onClick={scrollToPointSecond}>
              <div className="feature-item-point">
                <div className="feature-item-point-text">POINT</div>
                <div className="feature-item-point-number">02</div>
              </div>
              <div>
                <p className="feature-item-description">
                  個人情報の獲得数に
                  <br />
                  合わせたサービス体系
                </p>
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/feature-illustration-02.png")}
                  alt="個人情報の獲得数に合わせたサービス体系"
                  className="feature-illustration second"
                />
              </div>
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/feature-arrow.svg")}
                alt=""
                className="feature-arrow"
              />
            </div>
            <div className="feature-item third" onClick={scrollToPointThird}>
              <div className="feature-item-point">
                <div className="feature-item-point-text">POINT</div>
                <div className="feature-item-point-number">03</div>
              </div>
              <div>
                <p className="feature-item-description">
                  ターゲット学生に絞った
                  <br />
                  母集団形成が可能
                </p>
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/feature-illustration-03.png")}
                  alt="ターゲット学生に絞った母集団形成が可能"
                  className="feature-illustration third"
                />
              </div>
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/feature-arrow.svg")}
                alt=""
                className="feature-arrow"
              />
            </div>
          </div>
        </div>
      </Container>
    </Styled.FeatureContainer>
  )
}

interface FeaturePointProps {
  scrollToForm: () => void
}

const FeaturePointFirst = ({ scrollToForm }: FeaturePointProps) => {
  const isMobile = useMobileMedia()

  return (
    <Styled.FeaturePointFirstContainer>
      <Container size="Large" className="section-container">
        <Heading number="01" text="優秀人材に特化した学生データベース" />
        <ul className="point-list">
          <li className="point-list-item">
            <div className="point-list-item-heading">早期行動派の学生</div>
            <div className="point-list-item-content">
              <div className="point-list-item-img-wrapper">
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/database-point-1.png")}
                  alt="早期行動派の学生"
                  className="point-list-item-img first"
                />
              </div>
              <div className="point-list-item-description">
                <p>
                  大学1、2年生のうちから
                  <br />
                  動き始めている
                  <UnderlineText>
                    早期行動派の
                    <br />
                    24卒登録学生が半数以上在籍
                  </UnderlineText>
                </p>
              </div>
            </div>
          </li>
          <li className="point-list-item">
            <div className="point-list-item-heading">多種多様な職種を経験した学生</div>
            <div className="point-list-item-content">
              <div className="point-list-item-img-wrapper">
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/database-point-2.png")}
                  alt="多種多様な職種を経験した学生"
                  className="point-list-item-img second"
                />
              </div>
              <div className="point-list-item-description">
                <p>
                  早期行動学生はインターンシップで
                  <br />
                  <UnderlineText>多種多様な職種を経験</UnderlineText>
                </p>
              </div>
            </div>
          </li>
          <li className="point-list-item">
            <div className="point-list-item-heading">学歴</div>
            <div className="point-list-item-content">
              <div className="point-list-item-img-wrapper">
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/database-point-3.png")}
                  alt="学歴"
                  className="point-list-item-img third"
                />
              </div>
              <div className="point-list-item-description">
                <p>
                  <UnderlineText>
                    <span style={{ fontSize: "20px" }}>50</span>%以上
                  </UnderlineText>
                  が
                  <br />
                  GMARCH以上の高学歴
                </p>
              </div>
            </div>
          </li>
          <li className="point-list-item">
            <div className="point-list-item-heading">文系・理系の比率</div>
            <div className="point-list-item-content">
              <div className="point-list-item-img-wrapper">
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/database-point-4.png")}
                  alt="文理比"
                  className="point-list-item-img forth"
                />
              </div>
              <div className="point-list-item-description">
                <p>文理比は全国平均とほぼ同じ</p>
              </div>
            </div>
          </li>
        </ul>
        <div className="feature-point-1-appeal">
          <div className="feature-point-1-appeal-above">
            <div className="feature-point-1-appeal-above-pseudo-element"></div>
            優秀な早期行動学生が多数在籍
          </div>
          <div className="feature-point-1-appeal-below">
            <Pc>
              <p className="feature-point-1-appeal-below-text">早期から行動する優秀人材の割合が多いため</p>
            </Pc>
            <Sp>
              <p className="feature-point-1-appeal-below-text">早期から行動する</p>
              <p className="feature-point-1-appeal-below-text">優秀人材の割合が多いため</p>
            </Sp>
            <p className="feature-point-1-appeal-below-text green">ターゲット人材に出会いやすい</p>
          </div>
        </div>
        <CvAppeal
          imgSrc="/static/images/new-grad-scout/corp-contact/cv-appeal-people.png"
          description="詳しい学生のデータベースを確認する"
          onClick={scrollToForm}
        />
        <div className="question-container">
          <div className="question-heading">
            <div>
              <p className="question-heading-sub-text">Question</p>
              <p className="question-heading-text">
                なぜ Infra 新卒スカウトには{isMobile && <br />}優秀な人材が集まるの？
              </p>
            </div>
          </div>
          <div>
            <div className="question-content">
              <img
                src={staticPath(
                  "/static/images/new-grad-scout/corp-contact/database-question-long-internship-media.png"
                )}
                alt="国内最大級の長期インターン求人媒体を運用"
                className="question-content-img"
              />
              <div className="question-content-description">
                <p className="question-content-heading">国内最大級の長期インターン求人媒体を運用</p>
                <p className="question-content-text">
                  <UnderlineText fontSize={isMobile ? 12 : 14}>
                    長期インターンの採用に特化した求人媒体を6年間運営。
                  </UnderlineText>
                  累計の登録学生数は6万人を超えています。
                  <br />
                  長期インターン求人サイトの学生データベースを元にInfra新卒スカウトを提供しているため、
                  <UnderlineText fontSize={isMobile ? 12 : 14}>
                    早期から就職活動に向けて行動している学生にアプローチ
                  </UnderlineText>
                  できます。
                </p>
              </div>
            </div>
            <div className="question-content">
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/database-question-legallege.png")}
                alt="キャリア教育セミナーを開催"
                className="question-content-img"
              />
              <div className="question-content-description">
                <p className="question-content-heading">キャリア教育セミナーを開催</p>
                <p className="question-content-text">
                  学生限定で参加できるキャリア教育セミナーを多数開講。
                  <br />
                  “社会で価値を生み出す人材となる” をテーマにしたLegallegeでは
                  <UnderlineText fontSize={isMobile ? 12 : 14}>
                    プロジェクトマネジメントの考え方や、プレゼンテーションのスキルなどをセミナー形式で紹介。
                  </UnderlineText>
                  Infra 新卒スカウトではこういった
                  <UnderlineText fontSize={isMobile ? 12 : 14}>キャリア教育を受けた学生と出会う</UnderlineText>
                  ことができます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Styled.FeaturePointFirstContainer>
  )
}

const FeaturePointSecond = ({ scrollToForm }: FeaturePointProps) => {
  const isMobile = useMobileMedia()

  return (
    <Styled.FeaturePointSecondContainer>
      <Container size="Large" className="section-container">
        <Heading number="02" text="スカウト送付数ではなく個人情報の獲得数に合わせたサービス体系" />
        <div className="service-system-table">
          <div className="service-system-table-heading">Infra の個人情報の獲得数に合わせたサービス体系とは</div>
          <div className="service-system-table-content">
            <img
              src={staticPath("/static/images/new-grad-scout/corp-contact/service-system-with-response.png")}
              alt="返信あり"
              className="service-system-table-content-img"
            />
            <p className="service-system-table-content-description">
              最初に、学生に出会いたい数をご指定いただき、
              <UnderlineText fontSize={isMobile ? 12 : 14}>
                個人情報の獲得数に応じて料金が変動するシステム
              </UnderlineText>
              です。
              <br />
              スカウトに対して、学生からの返信で初めてスカウトチケットが消化されるので、無駄がなく、安心してスカウト送付することができます。
            </p>
          </div>
          <div className="service-system-table-content green">
            <img
              src={staticPath("/static/images/new-grad-scout/corp-contact/service-system-without-response.png")}
              alt="返信なし"
              className="service-system-table-content-img"
            />
            <div className="service-system-table-content-description">
              <p className="green">ここがポイント！</p>
              <p className="green large">自動補填のスカウトチケット</p>
              スカウトに対する学生からの返信が1週間なかった場合、
              <UnderlineText fontSize={isMobile ? 12 : 14}>その分のスカウトチケットは自動的に復活</UnderlineText>
              します。
            </div>
          </div>
        </div>
        <div className="guarantee-container">
          <div className="guarantee-heading">
            <span className="large green">100</span>
            <span className="green">名</span>
            の活躍人材と<span className="green">マッチング保証</span>
          </div>
          <p className="guarantee-description">
            学生の個人情報獲得数に合わせ{isMobile && <br />}サービス体系で
            {!isMobile && <br />}
            <UnderlineText fontSize={isMobile ? 18 : 25}>必ず、欲しい人材とのマッチング数を担保</UnderlineText>します。
          </p>
          <p className="guarantee-price">
            <span className="green">★</span>個人情報獲得単価は{isMobile && <br />}
            <span className="green">最低</span>
            <UnderlineText fontSize={isMobile ? 32 : 45}>4,000</UnderlineText>
            <span className="green">円</span>
          </p>
        </div>
        <CvAppeal
          imgSrc="/static/images/new-grad-scout/corp-contact/cv-appeal-search.png"
          description="詳しい料金体系を確認する"
          onClick={scrollToForm}
        />
      </Container>
    </Styled.FeaturePointSecondContainer>
  )
}

const FeaturePointThird = ({ scrollToForm }: FeaturePointProps) => {
  const isMobile = useMobileMedia()

  return (
    <Styled.FeaturePointThirdContainer>
      <Container size="Large" className="section-container">
        <Heading number="03" text="ターゲット学生に絞った母集団形成が可能" />
        <div className="targetting-container">
          <div className="targetting-heading">充実した検索機能でターゲット学生にピンポイントアプローチ</div>
          <div className="targetting-content">
            <div className="targetting-content-item first">
              <p className="targetting-content-item-heading">
                貴社のターゲット人材だけに
                <br />
                無駄なくアプローチできる検索機能
              </p>
              <p className="targetting-content-item-description">
                “学生検索” で、学歴、志望業界・職種、長期インターンや留学経験の有無など観点から絞り込み、
                <UnderlineText fontSize={isMobile ? 12 : 14}>学生の詳細なプロフィールを閲覧できます。</UnderlineText>
                自社にぴったりマッチする学生を見つけることが可能です。
              </p>
              <p className="targetting-content-item-img">
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/feature-illustration-03.png")}
                  alt="ターゲット学生に絞った母集団形成が可能"
                />
              </p>
            </div>
            <div className="targetting-content-item second">
              <p className="targetting-content-item-heading underline">
                <img src={staticPath("/static/images/new-grad-scout/corp-contact/targetting-search-icon.svg")} alt="" />
                こんな条件で学生を探すことができます
              </p>
              <div className="targetting-content-search">
                <div className="targetting-content-search-item-wrapper">
                  <div className="targetting-content-search-item">
                    <img
                      src={staticPath("/static/images/new-grad-scout/corp-contact/search-item-person.svg")}
                      className="targetting-content-search-item-img"
                      alt=""
                    />
                    基本情報
                    <br />
                    大学/ 学部 / 卒業年/ 所属大学エリア
                  </div>
                  <div className="targetting-content-search-item">
                    <img
                      src={staticPath("/static/images/new-grad-scout/corp-contact/search-item-folder.svg")}
                      className="targetting-content-search-item-img"
                      alt=""
                    />
                    志望職種 / 志望業界/ 志望企業タイプ
                  </div>
                  <div className="targetting-content-search-item">
                    <img
                      src={staticPath("/static/images/new-grad-scout/corp-contact/search-item-building.svg")}
                      className="targetting-content-search-item-img"
                      alt=""
                    />
                    就職先の選び方
                  </div>
                </div>
                <div className="targetting-content-search-item-wrapper">
                  <div className="targetting-content-search-item">
                    <img
                      src={staticPath("/static/images/new-grad-scout/corp-contact/search-item-note.svg")}
                      className="targetting-content-search-item-img"
                      alt=""
                    />
                    自己PR記入の有無
                  </div>
                  <div className="targetting-content-search-item">
                    <img
                      src={staticPath("/static/images/new-grad-scout/corp-contact/search-item-badge.svg")}
                      className="targetting-content-search-item-img"
                      alt=""
                    />
                    学生時代に行ったこと
                    <br />
                    （長期インターン / 学生団体等）
                  </div>
                  <div className="targetting-content-search-item">
                    <img
                      src={staticPath("/static/images/new-grad-scout/corp-contact/search-item-pc.svg")}
                      className="targetting-content-search-item-img"
                      alt=""
                    />
                    プログラミング / デザイン経験年数
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CvAppeal
          imgSrc={isMobile ? "" : "/static/images/new-grad-scout/corp-contact/cv-appeal-service.png"}
          description="無料でデモ画面を確認する"
          onClick={scrollToForm}
        />
      </Container>
    </Styled.FeaturePointThirdContainer>
  )
}

const Seminar = ({ scrollToForm }: FeaturePointProps) => {
  return (
    <Styled.SeminarContainer>
      <Container size="Large" className="section-container">
        <div className="seminar-heading-container">
          <div className="seminar-heading-more">＼ さらに ／</div>
          <h3 className="seminar-heading-main-text">
            <span className="seminar-heading-main-text-each">キャリア教育セミナーに参加している学生と</span>
            <br />
            <span className="seminar-heading-main-text-each">
              <span className="green">直接つながる</span>こともできる！
            </span>
          </h3>
          <p className="seminar-heading-sub-text">
            ※当社では学生向けのキャリア教育セミナーを多数企画、運営しています。
          </p>
        </div>
        <div className="seminar-introduction-container">
          <div className="seminar-introduction-heading">
            <p className="seminar-introduction-heading-sub-text">EVENT</p>
            <h3 className="seminar-introduction-heading-main-text">開催しているキャリア教育セミナーの一部をご紹介</h3>
          </div>
          <div className="seminar-introduction-item">
            <div className="seminar-introduction-item-content left">
              <p className="seminar-introduction-item-content-heading">企業と学生のマッチングイベント DRAFT</p>
              <p className="seminar-introduction-item-content-description">
                20分のターム制で、10名ほどの学生と対話しながら貴社の魅力を伝えていただくイベントです。
                <br />
                【学生人数】60~80名
                <br />
                【参加社数】5社程度
              </p>
              <Sp>
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/seminar-draft.png")}
                  className="seminar-introduction-item-img right"
                  alt="企業と学生のマッチングイベント DRAFT"
                />
              </Sp>
            </div>
            <Pc>
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/seminar-draft.png")}
                className="seminar-introduction-item-img right"
                alt="企業と学生のマッチングイベント DRAFT"
              />
            </Pc>
          </div>
          <div className="seminar-introduction-item">
            <Pc>
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/seminar-dive.png")}
                className="seminar-introduction-item-img"
                alt="就活シュミレーションインターン DIVE"
              />
            </Pc>
            <div className="seminar-introduction-item-content right">
              <p className="seminar-introduction-item-content-heading">就活シュミレーションインターン DIVE</p>
              <p className="seminar-introduction-item-content-description">
                参加学生が出展企業の採用担当者となり、企業理解と就職活動の理解を深めるワークイベントです。
                <br />
                【参加人数】40~60名
                <br />
                【参加社数】4社程度
              </p>
              <Sp>
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/seminar-dive.png")}
                  className="seminar-introduction-item-img"
                  alt="就活シュミレーションインターン DIVE"
                />
              </Sp>
            </div>
          </div>
          <div className="seminar-introduction-item">
            <div className="seminar-introduction-item-content left">
              <p className="seminar-introduction-item-content-heading">成長企業の経営者が生き方を語る TOPSCOPE</p>
              <p className="seminar-introduction-item-content-description">
                社長・役員にお越しいただき、経営者としての生き方やビジョンを語っていただきます。
                <br />
                【学生人数】30～50名
                <br />
                【参加社数】1社
              </p>
              <Sp>
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/seminar-topscope.png")}
                  className="seminar-introduction-item-img right"
                  alt="成長企業の経営者が生き方を語る TOPSCOPE"
                />
              </Sp>
            </div>
            <Pc>
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/seminar-topscope.png")}
                className="seminar-introduction-item-img right"
                alt="成長企業の経営者が生き方を語る TOPSCOPE"
              />
            </Pc>
          </div>
          <div className="seminar-introduction-item">
            <Pc>
              <img
                src={staticPath("/static/images/new-grad-scout/corp-contact/seminar-summit.png")}
                className="seminar-introduction-item-img"
                alt="長期インターン経験学生限定イベント SUMMIT"
              />
            </Pc>
            <div className="seminar-introduction-item-content right">
              <p className="seminar-introduction-item-content-heading">長期インターン経験学生限定イベント SUMMIT</p>
              <p className="seminar-introduction-item-content-description">
                長期インターンを通じて実践的な経験を積み力を磨いてきた学生と出会えるマッチングイベントです。
                <br />
                【学生人数】60~80名
                <br />
                【参加社数】5社程度
              </p>
              <Sp>
                <img
                  src={staticPath("/static/images/new-grad-scout/corp-contact/seminar-summit.png")}
                  className="seminar-introduction-item-img"
                  alt="長期インターン経験学生限定イベント SUMMIT"
                />
              </Sp>
            </div>
          </div>
        </div>
        <CvAppeal
          imgSrc="/static/images/new-grad-scout/corp-contact/cv-appeal-note.png"
          description="詳しい学生のデータベースやサービスを確認する"
          onClick={scrollToForm}
        />
      </Container>
    </Styled.SeminarContainer>
  )
}

interface UnderlineProps {
  fontSize?: number
  color?: string
}

const UnderlineText = styled.span<UnderlineProps>`
  padding-bottom: 2px;
  font-weight: bold;
  background: linear-gradient(transparent 65%, #ffff88 50%);
  ${({ fontSize, color }) =>
    css`
      font-size: ${fontSize ? fontSize : 14}px;
      color: ${color ? color : Color.Primary};
    `}
`
